export const REF_NAME = 'SHIPPINGLINE';
export const REF_PATH = 'shippingline';
export const NAME = 'Shipping line';
